export default __webpack_public_path__ + "static/media/higher_icon_clipboard_reversed.7217df7e.svg";